import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { TextField, Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

axios.defaults.withCredentials = true;
axios.defaults.timeout = 50000;

const KeyForm: React.FC = () => {
  const [username, setUsername] = useState<string>('');
  const [roleName, setRoleName] = useState<string>('');
  const [expirationTime, setExpirationTime] = useState<string>('');
  const [csrfToken, setCsrfToken] = useState<string | null>(null);
  const [host, setHost] = useState<string>('');
  const navigate = useNavigate();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const key = {
      username,
      roleName,
      expirationTime
    };

    axios.post(`${host}/userManagement/users/`, key, {
      headers: {
        'X-CSRFToken': csrfToken,
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        console.log('Key created successfully:', response.data);
        navigate(`/user/${response.data.sslSerialNumber}`, { state: { user: response.data } }); // Redirige al componente User con los datos del usuario creado
      })
      .catch(error => {
        console.error('There was an error creating the key!', error);
      });
  };

  const getCsrf = async (host: string) => {
    try {
      const response = await axios.get(`${host}/csfr/`);
      const token = response.data.csrfToken;
      setCsrfToken(token);
      console.log('CSRF Token:', token);
    } catch (error) {
      console.error('Error fetching CSRF token:', error);
    }
  };

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch('/config.json');
        const config = await response.json();
        setHost(config.host);
        console.log('Host loaded from config:', config.host);
        await getCsrf(config.host);
      } catch (error) {
        console.error('Error loading config:', error);
      }
    };

    fetchConfig();
  }, []);

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mt: 4,
        '& .MuiTextField-root': { mb: 2, width: '300px' },
        '& .MuiButton-root': { mt: 2 },
      }}
      onSubmit={handleSubmit}
    >
      <Typography variant="h4" component="h1" gutterBottom>
        Crear Llave
      </Typography>
      <TextField
        label="Key Name"
        variant="outlined"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        required
      />
      <TextField
        label="Role Name"
        variant="outlined"
        value={roleName}
        onChange={(e) => setRoleName(e.target.value)}
        required
      />
      <TextField
        label="Expiration Time"
        variant="outlined"
        value={expirationTime}
        onChange={(e) => setExpirationTime(e.target.value)}
        required
      />
      <Button type="submit" variant="contained" color="primary">
        Crear Llave
      </Button>
    </Box>
  );
};

export default KeyForm;
